/**
 * Created by Karol Kluska on 27.06.17.
 */

angular
  .module('app')
  .factory('PanelObserver', PanelObserver);

function PanelObserver() {
  var $this = this;
  $this.roomGroupCategoryFilterId = null;
  $this.originalRoomGroupCategoryFilterId = null;
  $this.categoryId = null;
  $this.originalCategoryId = null;
  $this.checkIn = null;
  $this.originalCheckIn = null;
  $this.checkOut = null;
  $this.originalCheckOut = null;
  $this.occupancy = null;
  $this.originalOccupancy = null;

  function getRoomGroupCategoryFilterId() {
    return $this.roomGroupCategoryFilterId;
  }

  function setRoomGroupCategoryFilterId(roomGroupCategoryFilterId) {
    if ($this.roomGroupCategoryFilterId === null) {
      $this.originalRoomGroupCategoryFilterId = angular.copy(roomGroupCategoryFilterId);
    }

    $this.roomGroupCategoryFilterId = angular.copy(roomGroupCategoryFilterId);
  }

  function isRoomGroupCategoryFilterIdChanged() {
    return $this.originalRoomGroupCategoryFilterId !== $this.roomGroupCategoryFilterId;
  }

  function getCategoryId() {
    return $this.categoryId;
  }

  function setCategoryId(categoryId) {
    if ($this.categoryId === null) {
      $this.originalCategoryId = angular.copy(categoryId);
    }

    $this.categoryId = angular.copy(categoryId);
  }

  function isCategoryIdChanged() {
    return $this.originalCategoryId !== $this.categoryId;
  }

  function getCheckIn() {
    return moment($this.checkIn);
  }

  function setCheckIn(date) {
    if ($this.checkIn === null) {
      $this.originalCheckIn = angular.copy(date);
    }

    $this.checkIn = angular.copy(date);
  }

  function isCheckInChanged() {
    return !moment($this.originalCheckIn).isSame(moment($this.checkIn), 'day');
  }

  function getCheckOut() {
    return moment($this.checkOut);
  }

  function setCheckOut(date) {
    if ($this.checkOut === null) {
      $this.originalCheckOut = angular.copy(date);
    }

    $this.checkOut = angular.copy(date);
  }

  function isCheckOutChanged() {
    return !moment($this.originalCheckOut).isSame(moment($this.checkOut), 'day');
  }

  function getOccupancy() {
    return $this.occupancy;
  }

  function setOccupancy(occupancy) {
    if ($this.occupancy === null) {
      $this.originalOccupancy = angular.copy(occupancy);
    }

    $this.occupancy = angular.copy(occupancy);
  }

  function isOccupancyChanged() {
    return !angular.equals($this.originalOccupancy, $this.occupancy);
  }

  function isPanelChanged() {
    return isRoomGroupCategoryFilterIdChanged() || isCategoryIdChanged() || isCheckInChanged() || isCheckOutChanged() || isOccupancyChanged();
  }

  return {
    getRoomGroupCategoryFilterId: getRoomGroupCategoryFilterId,
    setRoomGroupCategoryFilterId: setRoomGroupCategoryFilterId,
    getCategoryId: getCategoryId,
    setCategoryId: setCategoryId,
    getCheckIn: getCheckIn,
    setCheckIn: setCheckIn,
    getCheckOut: getCheckOut,
    setCheckOut: setCheckOut,
    getOccupancy: getOccupancy,
    setOccupancy: setOccupancy,
    isPanelChanged: isPanelChanged
  };
}
